import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'

import * as CommunityActionCreators from '../../actions/community'
import * as UnitActionCreators from '../../actions/unit'

import PageTitle from '../controls/PageTitle'
import BreadcrumbContainer from '../controls/BreadcrumbContainer'
import LoadingStatus from '../controls/LoadingStatusContainer'
import { splitOn } from '../../utils/SplitIO'
import { isAdmin } from '../../utils/AuthService'
import UnitAdminPanelView from '../admin/UnitAdminPanelView'
import UnitDetailsView from './UnitDetailsView'
import UnitAccessControlContainer from '../dooraccess/UnitAccessControlContainer'
import UnitAlertsContainer from '../alerts/UnitAlertsContainer'
import UnitChartContainer from './UnitChartContainer'
import UnitTimeseriesSummaryContainer from './UnitTimeseriesSummaryContainer'
import UnitControlContainer from './UnitControlContainer'

class UnitDetailsPage extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    classes: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    /* mapped state */
    auth: PropTypes.object.isRequired,
    communities: PropTypes.object.isRequired,
    units: PropTypes.object.isRequired,
    /* mapped dispatch */
    communityActions: PropTypes.object.isRequired,
    unitActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      auth: state.auth,
      communities: state.communities,
      units: state.units,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      communityActions: bindActionCreators(CommunityActionCreators, dispatch),
      unitActions: bindActionCreators(UnitActionCreators, dispatch),
    }
  }

  static styles = (theme) => ({
    gutters: {
      marginBottom: theme.spacing(2),
    },
  })

  componentDidMount() {
    this.props.unitActions.fetchUnit(this.unitId())
  }

  componentDidUpdate() {
    const unit = this.unit()

    if (unit.community_id) {
      this.props.communityActions.fetchCommunity(unit.community_id)
    }
  }

  unitId() {
    return parseInt(this.props.match.params.unitId, 10)
  }

  unit() {
    const { units } = this.props
    return units[this.unitId()] || {}
  }

  community() {
    const { communities } = this.props
    const unit = this.unit()
    return communities[unit.community_id] || {}
  }

  render() {
    const { auth, classes } = this.props
    const unit = this.unit()
    const unitId = this.unitId()

    return (
      <>
        <PageTitle title={unit.name} />
        <LoadingStatus />
        { unit.community_id && unit.name && (
          <BreadcrumbContainer items={[
            { title: this.community().name || 'Community', to: `/communities/${unit.community_id}` },
            { title: unit.name },
          ]}
          />
        )}

        { isAdmin(auth)
          && <UnitAdminPanelView unit={unit} />}

        <div className={classes.gutters}>
          <UnitDetailsView
            unit={unit}
            onSave={this.props.unitActions.saveUnit}
          />
        </div>

        <div className={classes.gutters}>
          <UnitAlertsContainer unitId={unitId} />
        </div>

        <div className={classes.gutters}>
          <UnitChartContainer unitId={unitId} />
        </div>

        <div className={classes.gutters}>
          <UnitTimeseriesSummaryContainer unitId={unitId} />
        </div>

        {splitOn('water_control', auth, { community_id: unit.community_id })
          && (
            <div className={classes.gutters}>
              <UnitControlContainer unitId={unitId} />
            </div>
          )}

        {splitOn('access_control', auth, { community_id: unit.community_id })
          && (
            <div className={classes.gutters}>
              <UnitAccessControlContainer unit={unit} />
            </div>
          )}
      </>
    )
  }
}

export default connect(
  UnitDetailsPage.mapStateToProps,
  UnitDetailsPage.mapDispatchToProps,
)(withStyles(UnitDetailsPage.styles)(UnitDetailsPage))
